import operatorToText from './operatorToText';

const dynamicDatePickerValueFormatter = value => {
  if (value?.operator === 'eqNull') {
    return 'None';
  }
  const data = value?.value?.split(',');
  if (data.length > 1) {
    return `${operatorToText(value?.operator)} ${data.join(' and ')}`;
  }
  return `${operatorToText(value?.operator)} ${data}`;
};

export default dynamicDatePickerValueFormatter;
